export enum RequestStatusEnum {
    evaluation = 0,
    accepted = 1,
    correction = 2,
    canceled = 3,
    corrected = 4,
    outdated = 5
}
